import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Constants, DOG_OWNER_PREMIUM_ENABLED } from "@eagerdog/constants";
import { helperService } from "../../services/helper.service";
import { useMessages } from "../../context/MessagesContext";

import UserMenu from "../../components/UserMenu/UserMenu";
import Icon from "../Icon/Icon";
import { Drawer, useDrawer, IMenuItem } from "src/components/Drawer/Drawer";

import styles from "../Messages/Messages.module.scss";

import logo from "../../assets/logo.svg";
import logoWhite from "../../assets/logo_white.svg";
import mobileLogo from "../../assets/eagerdog.svg";
import mobileLogoWhite from "../../assets/eagerdog_white.svg";

import "./Header.scss";

interface IProps {

}

const Header: React.FC<IProps> = (IProps) => {
  const location = useLocation();
  const isLoggedIn = helperService.isLoggedIn();
  const user = helperService.getUser();
  const club = helperService.getClub();
  const { unreadCount, isOpen, openMessages, closeMessages } = useMessages();

  const { toggle, isShown } = useDrawer();

  const isLoginPage = location.pathname === "/login";
  const isDiscoverPage = location.pathname === "/";

  const isLoggedOutOnLogin = isLoginPage && !isLoggedIn;
  const isClubManager = user.user_type === Constants.user_type.club_manager;
  const hasActiveSubscription = !DOG_OWNER_PREMIUM_ENABLED || (user.has_dog_profile_access ?? false);
  const clubHasActiveSubscription = club._id && (club.has_email_contacts_access || club.has_export_contacts_access);
  const isDogOwner = user.user_type === Constants.user_type.owner;

  // const showPremiumCta = !isLoginPage && (
  //   (isDogOwner && !hasActiveSubscription) || 
  //   (isClubManager && club._id && !clubHasActiveSubscription)
  // );

  const logoLink = isClubManager && club._id ? `/k/${club._id}` : "/";

  const menuItems:IMenuItem[] = [
    {
      label: "Events",
      url: "/events",
      icon: "events"
    }, {
      label: "Courses & Classes",
      url: "/courses",
      icon: "school"
    }, {
      label: "Clubs",
      url: "/kennel-clubs",
      icon: "group"
    }
  ];

  const [scrollY, setScrollY] = useState(0);
  const scrollBreakpoint:number = 20;

  const handleScroll = () => {
    setScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`Header ${isLoggedOutOnLogin ? ' login-page-mobile' : ''} ${isDiscoverPage ? 'discover' + (scrollY > scrollBreakpoint ? " whiteout" : "") : ''}`}>
      <div className="headerInner">
        <div onClick={() => { toggle(); }} className="mobile-menu">
          <Icon type="menu" className="mobile-icon" />
        </div>
        <div className="logo">
          {isDiscoverPage && <Link to={logoLink}>
            <img src={scrollY > scrollBreakpoint ? logo : logoWhite} alt="Eager Dog" className="desktop-logo"/>
            <img src={scrollY > scrollBreakpoint ? mobileLogo : mobileLogoWhite} alt="Eager Dog" className="mobile-logo"/>
          </Link>}
          {!isDiscoverPage && <Link to={logoLink}>
            <img src={logo} alt="Eager Dog" className="desktop-logo"/>
            <img src={mobileLogo} alt="Eager Dog" className="mobile-logo"/>
          </Link>}
        </div>
        
        {!isLoginPage && (
          <div className="navigation no-select">
            <Link 
              to="/events" 
              className={location.pathname === "/" ? "active" : ""}
            >
              Events
            </Link>
            <Link 
              to="/courses" 
              className={location.pathname === "/courses" ? "active" : ""}
            >
              Courses & Classes
            </Link>
            <Link 
              to="/kennel-clubs" 
              className={location.pathname === "/kennel-clubs" ? "active" : ""}
            >
              Clubs
            </Link>
          </div>
        )}
        
        {/*showPremiumCta && (
          <Link to="/premium" className="premium-cta no-select">
            <Icon type="star" className="orange" />
            <span className="premium-text">Upgrade to Premium</span>
          </Link>
        )*/}
        
        <div className="user">
          {isLoggedIn && (
            <div className={styles.notificationBell} onClick={isOpen ? closeMessages : openMessages} title="Messages">
              <Icon
                type="notification"
                className={[
                  styles.notificationIcon,
                  isDiscoverPage && scrollY <= scrollBreakpoint ? styles.onOrangeHeader : '',
                  isDiscoverPage && scrollY > scrollBreakpoint ? styles.whiteout : '',
                ].filter(Boolean).join(' ')}
              />
              {unreadCount > 0 && (
                <span className={styles.unreadBadge}>
                  {unreadCount > 99 ? '99+' : unreadCount}
                </span>
              )}
            </div>
          )}
          <UserMenu
            className={isDiscoverPage ? scrollY > scrollBreakpoint ? "discover whiteout" : "discover" : ""}
          />
        </div>
        <Drawer
          isShown={isShown}
          hide={toggle}
          menuItems={menuItems}
        />
      </div>
    </div>
  );
};

export default Header;
